import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "q-pa-sm tracksheet-marker-passages-popover__body" }
const _hoisted_2 = { class: "row items-center no-wrap q-pb-xs" }
const _hoisted_3 = { class: "text-subtitle2 ellipsis" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-grey-7 q-pa-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "text-caption text-grey-7 q-pa-sm",
  "data-testid": "tracksheet-marker-passages-popover-empty"
}
const _hoisted_6 = { class: "text-caption text-grey-7 q-pb-xs" }
const _hoisted_7 = { class: "row justify-end q-pt-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_PassagesTable = _resolveComponent("PassagesTable")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createBlock(_component_q_menu, {
    ref: "menu",
    "model-value": true,
    "no-parent-event": "",
    persistent: "",
    "no-focus": "",
    "no-refocus": "",
    anchor: _ctx.narrow ? 'bottom left' : 'top right',
    self: "top left",
    offset: _ctx.narrow ? [0, 4] : [8, 0],
    "max-width": "min(560px, calc(100vw - 16px))",
    "transition-show": "fade",
    "transition-hide": "fade",
    class: "tracksheet-marker-passages-popover",
    "data-testid": "tracksheet-marker-passages-popover",
    onPointerenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('popover-enter'))),
    onPointerleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('popover-leave'))),
    onPointerdown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('interact')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.markerName), 1),
          (_ctx.loaded)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "blue-brand",
                "text-color": "white",
                class: "q-ml-sm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.popover.total), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_space),
          _createVNode(_component_q_btn, {
            flat: "",
            round: "",
            dense: "",
            size: "sm",
            icon: "close",
            "aria-label": "Close passages",
            "data-testid": "tracksheet-marker-passages-popover-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        (!_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading passages… "))
          : (_ctx.popover.total === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No passages at this marker yet "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_6, " Newest " + _toDisplayString(_ctx.popover.rows.length) + " of " + _toDisplayString(_ctx.popover.total), 1),
                _createVNode(_component_PassagesTable, {
                  rows: _ctx.popover.rows,
                  columns: _ctx.columns,
                  "row-key": _ctx.rowKey,
                  "sort-method": _ctx.keepOrder,
                  pagination: { rowsPerPage: 0 },
                  "hide-bottom": "",
                  "dialog-source": _ctx.dialogSource,
                  "pig-run-id": _ctx.pigRunId,
                  active: _ctx.chartStepsHere,
                  "row-opens-chart": _ctx.narrow
                }, null, 8, ["rows", "columns", "row-key", "sort-method", "dialog-source", "pig-run-id", "active", "row-opens-chart"]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_q_btn, {
                    flat: "",
                    dense: "",
                    "no-caps": "",
                    color: "blue-brand",
                    "icon-right": "south",
                    label: _ctx.showAllText,
                    "data-testid": "tracksheet-marker-passages-popover-show-all",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-all', _ctx.pipelineSectionMarkerId)))
                  }, null, 8, ["label"])
                ])
              ], 64))
      ])
    ]),
    _: 1
  }, 8, ["anchor", "offset"]))
}